export const trial = {
  // Landing page
  'trial.cta.tryFree': 'Try for free',
  'trial.cta.tryFreeSubtitle': '30 days free, no commitment',

  // Trial badge
  'trial.badge.active': 'Free trial',
  'trial.badge.daysRemaining': '{days} days remaining',
  'trial.badge.expired': 'Trial expired',

  // Trial info
  'trial.info.title': '30-day free trial',
  'trial.info.description': 'Try SubventionPilot with no commitment and all essential features.',
  'trial.info.features.clients': 'Up to 3 client profiles',
  'trial.info.features.search': 'Unlimited subsidy search',
  'trial.info.features.ai': 'AI assistant included',
  'trial.info.features.export': 'Data export',
  'trial.info.noCard': 'No credit card required',

  // Client limit reached modal
  'trial.limit.title': 'Free trial limit reached',
  'trial.limit.description': 'You have reached the {limit} client profile limit of your free trial.',
  'trial.limit.currentCount': 'Current client profiles: {count}/{limit}',
  'trial.limit.upgradePrompt': 'To add more clients and access all features, upgrade to a subscription.',
  'trial.limit.upgradeButton': 'Upgrade to subscription',
  'trial.limit.later': 'Later',

  // Trial expired modal
  'trial.expired.title': 'Your free trial has expired',
  'trial.expired.description': 'Your 30-day trial period has ended. To continue using SubventionPilot, please choose a subscription.',
  'trial.expired.upgradeButton': 'Choose a subscription',
  'trial.expired.dataKept': 'Your data is kept for 30 days.',

  // Trial banner (dashboard)
  'trial.banner.title': 'Free trial',
  'trial.banner.daysLeft': '{days} days left on your trial',
  'trial.banner.clientsUsed': '{used}/{limit} client profiles used',
  'trial.banner.upgradeNow': 'Upgrade now',

  // Onboarding trial step
  'trial.onboarding.title': 'Start your free trial',
  'trial.onboarding.subtitle': '30 days to discover SubventionPilot',
  'trial.onboarding.benefit1.title': '3 client profiles',
  'trial.onboarding.benefit1.description': 'Create up to 3 profiles to test the platform',
  'trial.onboarding.benefit2.title': 'Full access',
  'trial.onboarding.benefit2.description': 'All search and analysis features',
  'trial.onboarding.benefit3.title': 'No commitment',
  'trial.onboarding.benefit3.description': 'No credit card required to start',
  'trial.onboarding.startButton': 'Start free trial',

  // Multi-user restriction
  'trial.multiuser.title': 'Feature reserved for subscribers',
  'trial.multiuser.description': 'Team member invitations are not available during the free trial.',
  'trial.multiuser.upgradePrompt': 'Upgrade to a subscription to invite collaborators.',
} as const;
